import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { PlusIcon } from 'framework/ui/mui-builder';
import AcceptanceArtifactModal from './AcceptanceArtifactModal';
import { ACCEPTANCE_ARTIFACT_MODAL_MODE } from '../../constants';

type AddAcceptanceArtifactModalProps = {
  onSuccess?: () => void | Promise<void>;
};

const AddAcceptanceArtifactModal = ({ onSuccess }: AddAcceptanceArtifactModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton sx={{ p: 0, ml: 1 }} size="small" aria-label="Add artifact" onClick={() => setIsOpen(true)}>
        <PlusIcon />
      </IconButton>
      <AcceptanceArtifactModal
        mode={ACCEPTANCE_ARTIFACT_MODAL_MODE.CREATE}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default AddAcceptanceArtifactModal;
